import React, { useState, useEffect } from 'react';
import Layout from 'components/common/DashboardLayout';
import { navigate } from '@reach/router';
import { FaArrowLeftLong, FaArrowRightLong } from 'react-icons/fa6';
import { FiSearch } from 'react-icons/fi';
import { Largemodal, Simplemodal } from 'components/common/simplifiedmodal';
import visaBanner from 'assets/viasForm/visaprompt.svg';
import checkIcon from 'assets/viasForm/circle-check.svg';
import { Platformbutton } from 'components/common/button/button';
import { useDispatch, useSelector } from 'react-redux';
import { handlevisaTypes } from 'appRedux/actions/visaForm';
import { logout } from 'assets/assets';
import './visatype.scss';
import img1 from 'assets/viasForm/o1visaSmall.svg';
import img2 from 'assets/viasForm/eb1small.svg';
import img3 from 'assets/viasForm/eb2small.svg';
import img4 from 'assets/viasForm/h1bsmall.svg';
import { Payment } from './payment';
import { fetchAllViasForms } from 'appRedux/actions/visaForm';
import { SimpleCancelmodal } from 'components/common/simplifiedmodal';
import api from 'appRedux/api';

// 0 - 1, EB - one, EB - two, H1B;
const pathwayVisa = [
  {
    abbr: '0-1',
    title: '0-1 Visa',
    text: 'Special Talent / Extraordinary Ability visa',
    buttonText: 'Submit Documents',
    visaType: '0-1',
    url: '0-1visa',
    img: img1,
    progress: 40,
    payment: 'FULLY PAID',
  },

  {
    abbr: 'EB-1',
    title: 'EB-1 Visa',
    text: 'Employment Based-1 visa',
    buttonText: 'Submit Documents',
    visaType: 'EB-one',
    url: 'EB-1visa',
    img: img2,
    progress: 20,
    payment: 'FULLY PAID',
  },

  {
    abbr: 'EB-2',
    title: 'EB-2 NIW Visa',
    text: 'Employment Based-2 National Interest Wavier (NIW) Visa',
    buttonText: 'Submit Documents',
    visaType: 'EB-two',
    url: 'EB-2NIWvisa',
    img: img3,
    progress: 0,
    payment: 'FULLY PAID',
  },

  {
    abbr: 'H1B',
    title: 'H1B Visa',
    text: 'H1B Visa',
    buttonText: 'Submit Documents',
    visaType: 'H1B',
    url: 'H1Bvisa',
    img: img4,
    progress: 0,
    payment: 'UNPAID',
  },

  {
    abbr: 'B1/B2',
    title: 'B-1 / B-2 Visa',
    text: 'Visit the USA for Business or Pleasure',
    buttonText: 'Submit Documents',
    visaType: 'B-1/B-2',
    url: 'B-1B-2visa',
    img: img4,
    progress: 10,
    payment: '25% PAID',
  },

  {
    abbr: 'F1',
    title: 'F1 Visa',
    text: 'F1 Visa',
    buttonText: 'Submit Documents',
    visaType: 'F1',
    url: 'F1visa',
    img: img4,
    progress: 0,
    payment: 'UNPAID',
  },
];

export const Visatypes = () => {
  const userD = useSelector(state => state.auth?.userData);

  const [visareqModal, setVisaReqModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [visatitle, setVisaTile] = useState('');
  const [visaLink, setVisaLink] = useState('');
  const [vType, setVType] = useState('');
  const [amountPaid, setAmountPaid] = useState(0);

  const [searchValue, setSearchValue] = useState('');
  const [filteredData, setFilteredData] = useState(null);
  const [searchResult, setSearchResult] = useState('');

  const dispatch = useDispatch();
  const handleSearchChange = event => {
    const value = event.target.value;
    setSearchValue(value);
  };

  useEffect(() => {
    dispatch(fetchAllViasForms(userD?.id));
  }, [userD]);

  const applyFilter = () => {
    if (searchValue.trim() === '') {
      setFilteredData(pathwayVisa);
      setSearchResult('');
    } else {
      const filteredTitles = pathwayVisa?.filter(visa =>
        visa.abbr.toLowerCase().includes(searchValue.toLowerCase()),
      );
      setSearchResult(filteredTitles.length > 0 ? '' : 'Visa not found');
      setFilteredData(filteredTitles);
    }
  };

  useEffect(() => {
    applyFilter();
  }, [searchValue]);

  // const visaTitle = 'EBtwo';
  const [matchingItems, setMatchingItems] = useState([]);
  const [nonMatchingItems, setNonMatchingItems] = useState([]);

  const Forms = useSelector(state => state.visaForm.submittedForms);

  const [formId, setFormId] = useState('');

  useEffect(() => {
    const foundItems = Forms
      ? Forms?.filter(item =>
          pathwayVisa.map(({ visaType }) => visaType).includes(item.visaType),
        )
      : [];

    const nonMatchingItems = Forms
      ? pathwayVisa?.filter(
          visa =>
            !Forms?.map(({ visaType }) => visaType).includes(visa.visaType),
        )
      : [];

    if (foundItems.length === 0 && nonMatchingItems.length === 0) {
      console.log('No matching or non-matching objects found.');
      setMatchingItems([]);
      setNonMatchingItems([]);
    } else {
      // console.log('Matching objects:', foundItems);
      // console.log('Non-matching objects:', nonMatchingItems);
      setMatchingItems(foundItems);
      setNonMatchingItems(nonMatchingItems);
    }
  }, [Forms]);

  return (
    <Layout>
      <div
        style={{ height: '85svh', overflowY: 'auto' }}
        className="mainvisaTypesSection"
      >
        <p
          onClick={() => {
            navigate('/pathways');
          }}
          style={{
            display: 'flex',
            color: '#67A948',
            alignItems: 'center',
            gap: '5px',
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          <FaArrowLeftLong /> Pathways
        </p>

        <div style={{ marginTop: '3rem' }}>
          <p
            className=" text-[#14290A] "
            style={{ fontWeight: '600', fontSize: '24px' }}
          >
            Select your Visa Type{' '}
          </p>
        </div>

        <div
          style={{
            background: '#fff',
            padding: '10px',
            color: '#858CA0',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '15px 10px',
            fontSize: '16px',
            marginTop: '2rem',
            marginBottom: '1rem',
            borderRadius: '10px',
          }}
          className="VisainputContainer"
        >
          {' '}
          <FiSearch />
          <input
            type="text"
            placeholder=" Search for visa type"
            value={searchValue}
            onChange={handleSearchChange}
            className="usInputField"
          />
        </div>
        <div className="visaTypes">
          {filteredData?.map(
            ({
              abbr,
              title,
              text,
              buttonText,
              url,
              visaType,
              img,
              progress,
              payment,
            }) => {
              return (
                <div key={title}>
                  <Mycard
                    abbr={abbr}
                    title={title}
                    text={text}
                    url={url}
                    buttonText={buttonText}
                    setVisaReqModal={setVisaReqModal}
                    visareqModal={visareqModal}
                    visatitle={visatitle}
                    setVisaTile={setVisaTile}
                    setVisaLink={setVisaLink}
                    visaLink={visaLink}
                    setVType={setVType}
                    visaType={visaType}
                    vType={vType}
                    img={img}
                    progress={progress}
                    payment={payment}
                    setPaymentModal={setPaymentModal}
                    matchingItems={matchingItems}
                    nonMatchingItems={nonMatchingItems}
                    formId={formId}
                    setFormId={setFormId}
                    setAmountPaid={setAmountPaid}
                    amountPaid={amountPaid}
                  />
                </div>
              );
            },
          )}
        </div>

        <p className="mt-2 text-red-600 text-center">{searchResult}</p>
      </div>
      <SimpleCancelmodal
        open={visareqModal}
        onClick={() => setVisaReqModal(false)}
      >
        <VisaRequirementModal
          visatitle={visatitle}
          visaLink={visaLink}
          vType={vType}
        />
        {/* <Payment /> */}
      </SimpleCancelmodal>

      <SimpleCancelmodal
        open={paymentModal}
        onClick={() => setPaymentModal(false)}
      >
        <Payment
          visatitle={visatitle}
          visaLink={visaLink}
          vType={vType}
          formId={formId}
          amountPaid={amountPaid}
        />
      </SimpleCancelmodal>
    </Layout>
  );
};

const Items = [
  { title: 'Resume & Credentials' },
  { title: 'Evidence of Employment with Filing Company (Your Company)' },
  { title: 'Employment in Critical Capacity' },
  { title: 'Recommendation Letters' },
  { title: 'Scholarly Articles, or Evidence of Authorship' },
  { title: 'Evidence of Judging the work of others' },
  { title: 'Awards and Award Nominations' },
  { title: 'Memberships' },
  { title: 'Newspaper Publications' },
  { title: 'Evidence of High Salary' },
  { title: 'Itinerary' },
  { title: 'Immigration Documents' },
];

const Mycard = props => {
  return (
    <div>
      <div
        className="visatypecard"
        style={{
          background: `${
            props.abbr === '0-1'
              ? // || props.abbr === 'B1/B2'
                '#EDFDFF'
              : // : props.abbr === 'EB-1' || props.abbr === 'F1'
                // ? '#FFF9F0'
                '#F9FAFB'
          }`,
          padding: '10px 20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          border: '1px solid #EAEAEA',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {/* <img
              src={props.img}
              alt=""
              style={{ width: '24px', height: '24px' }}
            /> */}

            <p
              style={{
                color: `${
                  props.abbr === '0-1'
                    ? // || props.abbr === 'B1/B2'
                      '#195742'
                    : // props.abbr === 'EB-1' || props.abbr === 'F1'
                      // ? '#936710'
                      '#667085'
                }`,
                fontWeight: '600',
                fontSize: '16px',
              }}
            >
              {props.title}
            </p>
          </div>

          {props.nonMatchingItems.map(item =>
            item.visaType === props.visaType ? (
              <p
                style={{
                  color: `${
                    props.abbr === '0-1'
                      ? // || props.abbr === 'B1/B2'
                        '#195742'
                      : // props.abbr === 'EB-1' || props.abbr === 'F1'
                        // ? '#936710'
                        '#667085'
                  }`,
                  fontSize: '11px',
                  border: `0.5px solid ${
                    props.abbr === '0-1' || props.abbr === 'B1/B2'
                      ? '#195742'
                      : props.abbr === 'EB-1' || props.abbr === 'F1'
                      ? '#936710'
                      : '#060E42'
                  }`,
                  padding: '2px 10px',
                  borderRadius: '5px',
                  fontWeight: '600',
                }}
              >
                {props.abbr === '0-1' ? 'UNPAID' : 'COMING SOON'}
              </p>
            ) : (
              <></>
            ),
          )}

          {props.matchingItems.map(item =>
            item.visaType === props.visaType ? (
              <p
                style={{
                  color: `${
                    props.abbr === '0-1'
                      ? // || props.abbr === 'B1/B2'
                        '#195742'
                      : // props.abbr === 'EB-1' || props.abbr === 'F1'
                        // ? '#936710'
                        '#667085'
                  }`,
                  fontSize: '11px',
                  border: `0.5px solid ${
                    props.abbr === '0-1' || props.abbr === 'B1/B2'
                      ? '#195742'
                      : props.abbr === 'EB-1' || props.abbr === 'F1'
                      ? '#936710'
                      : '#060E42'
                  }`,
                  padding: '2px 10px',
                  borderRadius: '5px',
                  fontWeight: '600',
                }}
              >
                {item.paymentPercent === null || item.paymentPercent == 0 ? (
                  'UNPAID'
                ) : item.paymentPercent == 100 ? (
                  'Fully Paid'
                ) : (
                  <>{item.paymentPercent} % paid</>
                )}
              </p>
            ) : (
              <></>
            ),
          )}
        </div>
        <p
          style={{
            color: `${
              props.abbr === '0-1'
                ? // || props.abbr === 'B1/B2'
                  '#195742'
                : // props.abbr === 'EB-1' || props.abbr === 'F1'
                  // ? '#936710'
                  '#667085'
            }`,
            fontWeight: '600',
          }}
        >
          {props.text}
        </p>

        {props.nonMatchingItems.map(item =>
          item.visaType === props.visaType ? (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div
                style={{
                  width: '100%',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  height: '5px',
                }}
              >
                <div
                  style={{
                    width: `${0}%`,
                    height: '100%',
                    backgroundColor: `${
                      props.abbr === '0-1' || props.abbr === 'B1/B2'
                        ? '#3B9B7B'
                        : props.abbr === 'EB-1' || props.abbr === 'F1'
                        ? '#BB8211'
                        : '#303D94'
                    }`,
                    borderRadius: '4px',
                    transition: 'width 0.1s ease-in-out',
                  }}
                ></div>
              </div>
              <p
                style={{
                  fontSize: '14px',
                }}
              >{`${0}%`}</p>
            </div>
          ) : (
            <></>
          ),
        )}

        {props.matchingItems.map(item =>
          item.visaType === props.visaType ? (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div
                style={{
                  width: '100%',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  height: '5px',
                }}
              >
                <div
                  style={{
                    width: `${
                      item.fileUploadPercentage === null
                        ? 0
                        : item.fileUploadPercentage
                    }%`,
                    height: '100%',
                    backgroundColor: `${
                      props.abbr === '0-1' || props.abbr === 'B1/B2'
                        ? '#3B9B7B'
                        : props.abbr === 'EB-1' || props.abbr === 'F1'
                        ? '#BB8211'
                        : '#303D94'
                    }`,
                    borderRadius: '4px',
                    transition: 'width 0.1s ease-in-out',
                  }}
                ></div>
              </div>
              <p
                style={{
                  fontSize: '14px',
                }}
              >{`${
                item.fileUploadPercentage === null
                  ? 0
                  : item.fileUploadPercentage
              }%`}</p>
            </div>
          ) : (
            <></>
          ),
        )}

        {props.matchingItems.map(item =>
          item.visaType === props.visaType ? (
            props.abbr === '0-1' ? (
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  color: `${
                    props.abbr === '0-1'
                      ? // || props.abbr === 'B1/B2'
                        '#195742'
                      : // props.abbr === 'EB-1' || props.abbr === 'F1'
                        // ? '#936710'
                        '#667085'
                  }`,
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
                //  {props.abbr === '0-1'?
                onClick={() => {
                  props.setVisaTile(props.title);
                  props.setVisaLink(props.url);
                  props.setVType(props.visaType);
                  props.setFormId(item.id);

                  item.amountPaid
                    ? props.setAmountPaid(item.amountPaid)
                    : props.setAmountPaid(0);

                  item.paymentPercent === null || item.paymentPercent == 0
                    ? props.setPaymentModal(true)
                    : props.setVisaReqModal(true);
                }}
              >
                {props.buttonText} <FaArrowRightLong />
              </p>
            ) : (
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  color: `${
                    props.abbr === '0-1'
                      ? // || props.abbr === 'B1/B2'
                        '#195742'
                      : // props.abbr === 'EB-1' || props.abbr === 'F1'
                        // ? '#936710'
                        '#667085'
                  }`,
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'not-allowed',
                }}
                //  {props.abbr === '0-1'?
                onClick={() => {}}
              >
                {props.buttonText} <FaArrowRightLong />
              </p>
            )
          ) : (
            <></>
          ),
        )}

        {props.nonMatchingItems.map(item =>
          item.visaType === props.visaType ? (
            props.abbr === '0-1' ? (
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  color: `${
                    props.abbr === '0-1'
                      ? // || props.abbr === 'B1/B2'
                        '#195742'
                      : // props.abbr === 'EB-1' || props.abbr === 'F1'
                        // ? '#936710'
                        '#667085'
                  }`,
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  props.setVisaTile(props.title);
                  props.setVisaLink(props.url);
                  props.setVType(props.visaType);
                  props.setFormId('');
                  props.setPaymentModal(true);
                }}
              >
                {props.buttonText} <FaArrowRightLong />
              </p>
            ) : (
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  color: `${
                    props.abbr === '0-1'
                      ? // || props.abbr === 'B1/B2'
                        '#195742'
                      : // props.abbr === 'EB-1' || props.abbr === 'F1'
                        // ? '#936710'
                        '#667085'
                  }`,
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'not-allowed',
                }}
                onClick={() => {}}
              >
                {props.buttonText} <FaArrowRightLong />
              </p>
            )
          ) : (
            <></>
          ),
        )}
      </div>
    </div>
  );
};

export const VisaRequirementModal = props => {
  const dispatch = useDispatch();

  return (
    <div style={{ width: '100%' }}>
      {/* <div
        style={{
          position: 'absolute',
          width: '100%',
          left: '0px',
          top: '0px',
          right: '0px',
          height: '15rem',
        }}
      > */}
      <img
        src={visaBanner}
        alt=""
        style={{
          position: 'absolute',
          width: '100%',
          left: '0px',
          top: '0px',
          right: '0px',
          height: '13rem',
        }}
      />
      {/* </div> */}
      <div className="VisarequirementsArticle" style={{ marginBottom: '1rem' }}>
        <h1 style={{ color: '#14290A', fontSize: '20px', fontWeight: '600' }}>
          Submit your {props.visatitle} requirements
        </h1>
        <p style={{ fontSize: '13px', fontWeight: '600', color: '#14290A' }}>
          Before you proceed you need to take notice of the following things:
        </p>
      </div>

      <ul
        style={{
          color: '#2B5219',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <li style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
          <img src={checkIcon} alt="" />
          This form is strictly for people applying for an {props.visatitle}. Do
          not proceed if you are not applying for an {props.visatitle} petition.
        </li>

        <li style={{ display: 'flex', gap: '5px', alignItems: 'flex-start' }}>
          <img src={checkIcon} alt="" />
          Screenshots and photographs of documents are generally not admissible
          by USCIS. Please upload very clear scanned copies of all documents.
        </li>

        <li style={{ display: 'flex', gap: '5px' }}>
          <img src={checkIcon} alt="" />
          Form accept only upload in PDF format.
          {/* This form is comprised of 12 different sections which include: */}
        </li>
      </ul>

      {/* <ul style={{ paddingLeft: '20px' }}>
        {Items.map(({ title }) => {
          return (
            <li
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                color: '#2B5219',
                fontSize: '12px',
                fontWeight: '600',
              }}
            >
              <p
                style={{
                  background: '#000',
                  height: '6px',
                  width: '6px',
                  borderRadius: '100%',
                }}
              ></p>{' '}
              {title}
            </li>
          );
        })}
      </ul> */}

      <p style={{ color: '#518C36', fontWeight: '500' }}>
        NB: You can save your progress and continue uploading your files at your
        leisure before the deadline.
      </p>

      <div className="mb-4"></div>
      <Platformbutton
        type="normal"
        name={'Proceed'}
        click={() => {
          dispatch(handlevisaTypes(props.visatitle, props.vType));
          navigate(`/pathways/${props.visaLink}`);
        }}
      />
    </div>
  );
};
